// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hide-item ::ng-deep app-item .item-box {
  display: none;
}
.hide-item ::ng-deep app-item .item-box-hidding {
  display: block !important;
}

ion-toolbar {
  --min-height: 48px;
}

.filters-row .view-btn {
  width: -moz-fit-content;
  width: fit-content;
}

.filters-row ion-item :host ::ng-deep .adir {
  color: #0ec254;
}
.filters-row ion-item :host ::ng-deep ion-button.button-clear {
  --color: var(--button-a-text);
  --color-activated: var(--button-a-text);
}

:host ::ng-deep .filters-row ion-toolbar ion-button.filters-button.button-clear {
  --color: var(--button-a-text);
  --color-activated: var(--button-a-text);
}

.active-filters-row {
  margin-top: 5px;
}
.active-filters-row ion-badge {
  margin: 0 2px;
  --background: var(--button-b-background);
  --color: var(--button-b-text);
}

.view-btn.active {
  opacity: 0.5;
}

.items-list.list-ios {
  margin: 0;
}

.cart-icon {
  font-size: 100px;
  color: #d2d2d2;
  padding-top: 10px;
}

.items-list {
  padding: 0;
}
.items-list .flex-grid {
  display: flex;
  flex-wrap: wrap;
  /* flex: 0 0 32.9%; */
  gap: 2px;
  justify-content: center;
}
.items-list .flex-grid .item-col {
  flex: 0 0 48%;
  transition: height 0.5s ease;
  border-radius: 5px;
}
.items-list .flex-grid .item-col-big {
  flex: 0 0 65.8%;
}
.items-list .flex-grid.small .item-col {
  flex: 0 0 48%;
}
.items-list .flex-grid.small .item-col-big {
  flex: 0 0 99.9%;
}
.items-list .flex-grid.table .item-col {
  flex: 0 0 99.9%;
}
.items-list .flex-grid.table .item-col-big {
  flex: 0 0 99.9%;
}
@media (max-width: 450px) {
  .items-list .flex-grid.smaller .item-col {
    flex: 0 0 24%;
  }
  .items-list .flex-grid.small .item-col {
    flex: 0 0 100%;
  }
  .items-list .flex-grid.big .item-col {
    flex: 0 0 48.4%;
  }
  .items-list .flex-grid.big .item-col-big {
    flex: 0 0 99.9%;
  }
  .items-list .flex-grid.big.agentTechnicalTool .item-col {
    flex: 0 0 48.9%;
  }
  .items-list .flex-grid.big.agentTechnicalTool .item-col-big {
    flex: 0 0 49.9%;
  }
}
@media (min-width: 450px) {
  .items-list .flex-grid.small .item-col {
    flex: 0 0 100%;
  }
  .items-list .flex-grid.biger .item-col {
    flex: 0 0 48.4%;
  }
  .items-list .flex-grid.big .item-col {
    flex: 0 0 48.4%;
  }
  .items-list .flex-grid.big .item-col-big {
    flex: 0 0 99.9%;
  }
}
@media (min-width: 800px) {
  .items-list .flex-grid.smaller .item-col {
    flex: 0 0 16%;
  }
  .items-list .flex-grid.small .item-col {
    flex: 0 0 99%;
  }
  .items-list .flex-grid.big .item-col, .items-list .flex-grid.big.agentTechnicalTool .item-col {
    flex: 0 0 32.3%;
  }
  .items-list .flex-grid.big .item-col-big, .items-list .flex-grid.big.agentTechnicalTool .item-col-big {
    flex: 0 0 65.8%;
  }
}
@media (min-width: 1286px) {
  .items-list .flex-grid.big .item-col, .items-list .flex-grid.big.agentTechnicalTool .item-col {
    flex: 0 0 24.6%;
  }
  .items-list .flex-grid.big .item-col.big-screen, .items-list .flex-grid.big.agentTechnicalTool .item-col.big-screen {
    flex: 0 0 32.3%;
  }
  .items-list .flex-grid.big .item-col-big, .items-list .flex-grid.big.agentTechnicalTool .item-col-big {
    flex: 0 0 48.9%;
  }
  .items-list .flex-grid.small .item-col {
    flex: 0 0 100%;
  }
}
.items-list ion-row {
  padding: 0 5px;
}

.slideBox {
  padding: 0 3px;
  margin-bottom: 30px;
}

ion-popover.settings-popover {
  --width: 200px !important;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/components/item-list/item-list.component.scss"],"names":[],"mappings":"AAGM;EACE,aAAA;AAFR;AAKM;EACE,yBAAA;AAHR;;AAaA;EACE,kBAAA;AAVF;;AAiBE;EACE,uBAAA;EAAA,kBAAA;AAdJ;;AA+BI;EACE,cAAA;AA5BN;AA+BI;EACE,6BAAA;EACA,uCAAA;AA7BN;;AAoCI;EACE,6BAAA;EACA,uCAAA;AAjCN;;AAuCA;EAEE,eAAA;AArCF;AAuCE;EACE,aAAA;EAEA,wCAAA;EACA,6BAAA;AAtCJ;;AA0CA;EACE,YAAA;AAvCF;;AA0CA;EACE,SAAA;AAvCF;;AA0CA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AAvCF;;AA2CA;EACE,UAAA;AAxCF;AA0CE;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EAEA,QAAA;EACA,uBAAA;AAzCJ;AA2CI;EACE,aAAA;EAEA,4BAAA;EACA,kBAAA;AA1CN;AAgDI;EACE,eAAA;AA9CN;AAuDI;EACE,aAAA;AArDN;AAwDI;EACE,eAAA;AAtDN;AA2DI;EACE,eAAA;AAzDN;AA4DI;EACE,eAAA;AA1DN;AA+DE;EAGI;IACE,aAAA;EA/DN;EAoEI;IACE,cAAA;EAlEN;EAsEI;IACE,eAAA;EApEN;EAuEI;IACE,eAAA;EArEN;EA0EI;IACE,eAAA;EAxEN;EA2EI;IACE,eAAA;EAzEN;AACF;AA6EE;EAEI;IACE,cAAA;EA5EN;EAkFI;IACE,eAAA;EAhFN;EAoFI;IACE,eAAA;EAlFN;EAqFI;IACE,eAAA;EAnFN;AACF;AAiGE;EAEI;IACE,aAAA;EAhGN;EAoGI;IACE,aAAA;EAlGN;EAsGI;IACE,eAAA;EApGN;EAuGI;IACE,eAAA;EArGN;AACF;AAyGE;EAGI;IACE,eAAA;EAzGN;EA4GI;IACE,eAAA;EA1GN;EA6GI;IACE,eAAA;EA3GN;EAgHI;IACE,cAAA;EA9GN;AACF;AAkHE;EACE,cAAA;AAhHJ;;AA+HA;EACE,cAAA;EAEA,mBAAA;AA7HF;;AAiIA;EACI,yBAAA;AA9HJ","sourcesContent":[".hide-item {\n  ::ng-deep {\n    app-item {\n      .item-box {\n        display: none;\n      }\n\n      .item-box-hidding {\n        display: block !important;\n      }\n    }\n  }\n}\n\n//.item {\n//  height: 310px;\n//}\n\nion-toolbar {\n  --min-height: 48px;\n}\n\n.filters-row {\n  //margin: 3px 0;\n  //padding: 0 9px;\n\n  .view-btn {\n    width: fit-content;\n  }\n}\n\n.filters-row ion-item {\n  //box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 0px 5px 0 rgba(0, 0, 0, .12);\n  //border-radius: 3px;\n\n  //border-color: var(--button-a-background);\n  //--color: var(--button-a-text);\n\n  ion-buttons ion-button.button-clear {\n    //--color: var(--button-a-text);\n    //--color-activated: var(--button-a-text);\n  }\n\n  :host ::ng-deep {\n    .adir {\n      color: #0ec254;\n    }\n\n    ion-button.button-clear {\n      --color: var(--button-a-text);\n      --color-activated: var(--button-a-text);\n    }\n  }\n}\n\n:host ::ng-deep {\n  .filters-row ion-toolbar {\n    ion-button.filters-button.button-clear {\n      --color: var(--button-a-text);\n      --color-activated: var(--button-a-text);\n    }\n  }\n\n}\n\n.active-filters-row {\n  //padding: 5px;\n  margin-top: 5px;\n\n  ion-badge {\n    margin: 0 2px;\n\n    --background: var(--button-b-background);\n    --color: var(--button-b-text);\n  }\n}\n\n.view-btn.active {\n  opacity: 0.5;\n}\n\n.items-list.list-ios {\n  margin: 0;\n}\n\n.cart-icon {\n  font-size: 100px;\n  color: #d2d2d2;\n  padding-top: 10px;\n}\n\n\n.items-list {\n  padding: 0;\n\n  .flex-grid {\n    display: flex;\n    flex-wrap: wrap;\n    /* flex: 0 0 32.9%; */\n    //gap: 11px;\n    gap: 2px;\n    justify-content: center;\n\n    .item-col {\n      flex: 0 0 48%;\n\n      transition: height 0.5s ease;\n      border-radius: 5px;\n\n      //width: 33%;\n      //display: contents;\n    }\n\n    .item-col-big {\n      flex: 0 0 65.8%;\n    }\n\n    .item-col.inCart{\n      //box-shadow: 0px 0px 6px 0px var(--button-a-background);\n    }\n  }\n\n  .flex-grid.small {\n    .item-col {\n      flex: 0 0 48%;\n    }\n\n    .item-col-big {\n      flex: 0 0 99.9%;\n    }\n  }\n\n  .flex-grid.table {\n    .item-col {\n      flex: 0 0 99.9%;\n    }\n\n    .item-col-big {\n      flex: 0 0 99.9%;\n    }\n  }\n\n\n  @media (max-width: 450px) {\n\n    .flex-grid.smaller {\n      .item-col {\n        flex: 0 0 24%;\n      }\n    }\n\n    .flex-grid.small {\n      .item-col {\n        flex: 0 0 100%;\n      }\n    }\n    .flex-grid.big {\n      .item-col {\n        flex: 0 0 48.4%;\n      }\n\n      .item-col-big {\n        flex: 0 0 99.9%;\n      }\n    }\n\n    .flex-grid.big.agentTechnicalTool {\n      .item-col {\n        flex: 0 0 48.9%;\n      }\n\n      .item-col-big {\n        flex: 0 0 49.9%;\n      }\n    }\n  }\n\n  @media (min-width: 450px) {\n    .flex-grid.small {\n      .item-col {\n        flex: 0 0 100%;\n      }\n    }\n\n\n    .flex-grid.biger {\n      .item-col {\n        flex: 0 0 48.4%;\n      }\n    }\n    .flex-grid.big {\n      .item-col {\n        flex: 0 0 48.4%;\n      }\n\n      .item-col-big {\n        flex: 0 0 99.9%;\n      }\n    }\n\n    //.flex-grid.big.agentTechnicalTool {\n    //  .item-col {\n    //    flex: 0 0 99.9%;\n    //  }\n    //\n    //  .item-col-big {\n    //    flex: 0 0 99.9%;\n    //  }\n    //}\n  }\n\n  @media (min-width: 800px) {\n    .flex-grid.smaller {\n      .item-col {\n        flex: 0 0 16%;\n      }\n    }\n    .flex-grid.small {\n      .item-col {\n        flex: 0 0 99%;\n      }\n    }\n    .flex-grid.big, .flex-grid.big.agentTechnicalTool {\n      .item-col {\n        flex: 0 0 32.3%;\n      }\n\n      .item-col-big {\n        flex: 0 0 65.8%;\n      }\n    }\n  }\n\n  @media (min-width: 1286px) {\n\n    .flex-grid.big, .flex-grid.big.agentTechnicalTool {\n      .item-col {\n        flex: 0 0 24.6%;\n      }\n\n      .item-col.big-screen{\n        flex: 0 0 32.3%;\n      }\n\n      .item-col-big {\n        flex: 0 0 48.9%;\n      }\n    }\n\n    .flex-grid.small {\n      .item-col {\n        flex: 0 0 100%;\n      }\n    }\n  }\n\n  ion-row {\n    padding: 0 5px;\n\n    //ion-col {\n    //  margin-bottom: 5px;\n    //}\n\n    //@media screen and (min-width: 500px){\n    //  .item-col:nth-child(2n)\n    //  {\n    //    padding-right: 3px;\n    //  }\n    //}\n  }\n}\n\n.slideBox {\n  padding: 0 3px;\n  //background: #e1e1e1;\n  margin-bottom: 30px;\n}\n\n\nion-popover.settings-popover{\n    --width: 200px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
